import { useContext } from 'react';
import { getFnContext } from './context';

export const useGetGetFn = () => {
  const getFn = useContext(getFnContext);
  return getFn;
};
